module.exports = __webpack_public_path__ + "img/brand-cases17.ca9718e7.png";